import { useState as a, useEffect as o } from "react";
import { useHashActiveIdState as h } from "./use-hash-active-id-state.js";
const l = (t) => {
  const [c, s] = a(null);
  o(() => {
    const e = window.location.hash.substring(1);
    e && (t != null && t.includes(e)) && s(e);
  }, []);
  const { activeId: i, setActiveId: n } = h(c);
  return { activeId: i, setActiveId: n, isActiveIdFromHash: c !== null };
};
export {
  l as useHashSyncedActiveId
};
